import {Component, OnInit, ViewChild} from '@angular/core';
import {TableService} from '../_services/table.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import {Globals} from "../globals";
import {TsaService} from '../_services/tsa.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
  providers: [MessageService, ConfirmationService]
})
export class AdminComponent implements OnInit {
  results: {[key: string]: any}[] = [];
  selectedResults: {[key: string]: any}[] = [];
  result: {[key: string]: any} = {};

  cols: {field: string, header: string}[] = [];
  loading: boolean = false;

  rowEditor: boolean = false;
  submitted: boolean = false;

  tableName = 'Airport Grouping';

  files: File[] = [];

  selectedObjects: any[] = [];
  @ViewChild('airportInput') el: any;
  inputWComma = false;
  airports: any[] = [];
  filteredAirports: any[] = [];

  constructor(private messageService: MessageService, private confirmationService: ConfirmationService,
              private tableService: TableService, private globals: Globals, private serviceApt: TsaService) { }

  ngOnInit(): void {
    this.tableService.setTable(this.globals.userGroup + '.GROUP_AIRPORT');
    this.getResults();

    // Generate unique airport list
    let flags: boolean[] = [];
    for (let apt of this.globals.airports) {
      if(apt.name) { // Skip groups, which have empty AIRPORT_NAME
        this.airports.push(apt);
        this.filteredAirports.push(apt);
      }
    }

  }

  getResults(): void {
    this.loading = true;
    this.tableService.getTable().subscribe((results: any) => {
      this.loading = false;
      if(results == null) {
        this.messageService.add({
          severity: 'error', summary: 'Error',
          detail: 'No result is found for ' + this.tableName + '!', life: 3000
        });
      }  else {
        this.results = results.data;
        this.cols = [];
        if(results.data.length > 0) {
          Object.keys(results.data[0]).forEach(key => {
            this.cols.push({field: key, header: key.toUpperCase()})
          });
        }
      }
    });
  }

  /**
   * Edit a record
   * @param result
   */
  editResult(result: any) {
    this.selectedObjects = [];

    this.result = {...result};
    this.airports.forEach((item) => {
      if (this.result.MEMBERS.includes(item.code) && !this.selectedObjects.includes(item)) this.selectedObjects.push(item);
    })
    this.rowEditor = true;
  }

  /**
   * Delete a record
   * @param result
   */
  deleteResult(result: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this record?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let ID = result.ID;
        this.loading = true;
        this.tableService.deleteResult(result).subscribe((status: any) => {
          this.loading = false;
          if(status) {
            this.messageService.add({
              severity: 'success',
              summary: 'Successful',
              detail: 'The record has been successfully deleted!',
              life: 3000
            });
            this.results = this.results.filter(val => val.ID !== ID);
            this.result = {};
          } else {
            this.messageService.add({
              severity: 'warn',
              summary: 'Failure',
              detail: 'Something went wrong. The record has not been deleted!',
              life: 3000
            });
          }
        });
      }
    });
  }

  /**
   * Delete all selected records
   */
  deleteSelectedResults() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the selected records?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let obj;
        let IDs = '';
        this.selectedResults.forEach(result => {
          IDs += result.ID + ',';
        })
        obj = {'ID': IDs.substring(0, IDs.length - 1)};

        this.loading = true;
        this.tableService.deleteResult(obj).subscribe((status: any) => {
          this.loading = false;
          if(status) {
            this.messageService.add({severity: 'success', summary: 'Successful',
                detail: 'Records deleted', life: 3000});
            this.results = this.results.filter(val => !this.selectedResults.includes(val));
            this.selectedResults = [];
          } else {
            this.messageService.add({severity: 'warn', summary: 'Failure',
              detail: 'Something wrong. Records not deleted!', life: 3000});
          }
        });
      }
    });
  }

  openNew() {
    this.selectedObjects = [];

    this.result = {};
    this.submitted = false;
    this.rowEditor = true;
  }

  /**
   * Save a updated row
   * @param result: updated row
   */
  saveResult(result?: any) {
    // Add * at the end
    if(!this.result.CODE.endsWith("*")) this.result.CODE += "*";
    if(this.result.DESCRIPTION == null) this.result.DESCRIPTION = "";

    // Convert content in the autocomplete to a string
    this.result.MEMBERS = '';
    this.selectedObjects.forEach((obj) => {
      this.result.MEMBERS +=  obj.code + ",";
    })
    if(this.result.MEMBERS.endsWith(",")) this.result.MEMBERS = this.result.MEMBERS.substring(0, this.result.MEMBERS.length-1);

    this.rowEditor = false;
    this.loading = true;
    this.tableService.saveResult(this.result).subscribe((record: any) => {
      this.loading = false;
      if (this.result.ID) {
        this.result = record;
        this.results[this.findIndexById(this.result.ID)] = this.result;
        this.messageService.add({severity:'success', summary: 'Successful',
          detail: 'Record updated!', life: 3000});
      } else {
        this.result = record;
        this.result.ID = 1;
        this.results.push(this.result);
        this.messageService.add({severity:'success', summary: 'Successful',
          detail: 'New record created!', life: 3000});
      }
      
      this.results = [...this.results];
      this.result = {};
    });
  }

  hideDialog() {
    this.selectedObjects = [];
    this.rowEditor = false;
    this.submitted = false;
  }

  close() {
    this.result = {};
    window.location.replace("/#tsaplus");
  }

  findIndexById(id: number): number {
    let index = -1;
    for (let i = 0; i < this.results.length; i++) {
        if (this.results[i].ID === id) {
            index = i;
            break;
        }
    }
    return index;
  } 


  /** Functions about autocompletion **/
  /**
   * Use typeahead to filter airports
   * @param event - event triggered
   */
  filterAirport(event: any): void {
    let filtered: any[] = [];
    let queries = event.query.split(",");
    for (let i = 0; i < this.airports.length; i++) {
      let item = this.airports[i];
      if(queries.length > 1) {
        // search code only
        for (let query of queries) {
          query = query.trim();
          if (query.length>=3) {
            if (item.display.toLowerCase().substr(0,3) == query.toLowerCase()) {
              item.order = 0;
              filtered.push(item);
            }
          }
        }
      } else {
        // can search name
        let query = queries[0];
        let idx = item.display.toLowerCase().indexOf(query.toLowerCase());
        let idx2 = item.display.indexOf(query);
        if (idx >= 0) {
          if (idx2 == 0) item.order = 0;
          else if (idx == 0) item.order = 1;
          else if (idx2 > 0) item.order = 2;
          else item.order = 3;
          filtered.push(item);
        }
      }
    }
    // Order by Code first and then by name
    this.filteredAirports = filtered.sort(function(a,b){return a.order-b.order});
  }


  selectAirport(obj:any): void {
    if(this.el.suggestions != null && this.inputWComma) {
      for(let s of this.el.suggestions) {
        if (!this.selectedObjects.includes(s)) this.selectedObjects.push(s);
      }
    }
  }

  airportKeyUp(obj:any): void {
    if (obj.target.value.indexOf(",")>0) this.inputWComma = true;
  }

  clearAirports(): void {
    this.selectedObjects = [];
  }
}
